import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { BiData, PureBiData } from '@wix/da-bi/pkg/events';
import { ReferralType, BiEventType } from '@wix/da-bi/pkg/constants';
import StandardMenu from '../../../../Dropdown/MenuPreset/StandardMenu';
import { getDeviationResourceType } from '../../../../DeviationViews/_helpers';
import { useDeviationAttributes } from '../../../../DeviationViews/hooks/useDeviationAttributes';
import { useVerification } from '../../../../VerificationPopup/withVerification';
import { useFreeDownloadAction, usePremiumDownloadAction } from '../../DownloadButton/hooks';
import { getAllowOffers, getHasBuyItNow } from '../../../../utils/adoptables';
import s from './MoreMenuContent.scss';
// This is used only on desktop
const MoreMenuContent = ({ deviation , isOwner , closeTooltip =()=>null , showReportModal , showDesktopDeviationSharePopup , showNftLinkPopup , shareDeviationToPost , showAddToGroupPopup , showAwardBadgePopup , onToggleCommentPanel  })=>{
    var _deviation_author;
    const { t  } = useTranslation();
    const { restrictToVerifiedAndLoggedIn  } = useVerification();
    const { isShareable , isReportable , hasNft , isCommentable , isCoreBadgeAwardable  } = useDeviationAttributes(deviation, isOwner);
    const adoptableOffers = getAllowOffers(deviation);
    const isAnAdoptable = deviation.isAdoptable;
    const adoptableBuyItNow = getHasBuyItNow(deviation);
    const overflowByDefault = isAnAdoptable && adoptableOffers && adoptableBuyItNow; // when two buttons are shown, overflow actions end up here
    const overflowByResponsiveDesign = isAnAdoptable && !overflowByDefault; // show these buttons when in lower resolutions
    const freeDownloadAction = useFreeDownloadAction(deviation, isOwner);
    const premiumDownloadAction = usePremiumDownloadAction(deviation, isOwner);
    var _deviation_author_useridUuid;
    return /*#__PURE__*/ React.createElement(StandardMenu, {
        className: s['menu'],
        id: "actionbar-more-menu",
        items: [
            isAnAdoptable && isCommentable && {
                className: c(s['overflow-responsive']),
                value: 'comment',
                label: t('actionbar.comment.label'),
                onClick: onToggleCommentPanel,
                biData: BiData({
                    evid: 105,
                    typeid: getDeviationResourceType(deviation),
                    itemid: deviation.deviationId,
                    creatorid: (_deviation_author_useridUuid = (_deviation_author = deviation.author) === null || _deviation_author === void 0 ? void 0 : _deviation_author.useridUuid) !== null && _deviation_author_useridUuid !== void 0 ? _deviation_author_useridUuid : ''
                })
            },
            isAnAdoptable && premiumDownloadAction.hasAction && {
                className: c(overflowByDefault && s['overflowed'], overflowByResponsiveDesign && s['overflow-responsive']),
                value: 'download',
                label: t('actionbar.premiumDownload'),
                link: premiumDownloadAction.href,
                onClick: ()=>{
                    premiumDownloadAction.onClick && premiumDownloadAction.onClick();
                    closeTooltip();
                },
                biData: PureBiData({
                    evid: 350,
                    ispaiddownload: 1,
                    deviationid: deviation.deviationId,
                    sectionname: 'action_bar'
                })
            },
            isAnAdoptable && freeDownloadAction.hasAction && {
                className: c(overflowByDefault && s['overflowed'], overflowByResponsiveDesign && s['overflow-responsive']),
                value: 'download',
                label: t('actionbar.freeDownload'),
                link: freeDownloadAction.href,
                onClick: ()=>{
                    freeDownloadAction.onClick && freeDownloadAction.onClick();
                    closeTooltip();
                },
                biData: PureBiData({
                    evid: 350,
                    ispaiddownload: 0,
                    deviationid: deviation.deviationId,
                    sectionname: 'action_bar'
                })
            },
            !!showAddToGroupPopup && {
                value: 'addToGroup',
                label: t('actionbar.addToGroup'),
                onClick: ()=>{
                    showAddToGroupPopup();
                    closeTooltip();
                },
                biData: BiData({
                    evid: 340,
                    deviationid: deviation.deviationId,
                    sectionname: 'add_to_group'
                })
            },
            isAnAdoptable && isCoreBadgeAwardable && {
                value: 'awardBadge',
                label: t('actionbar.awardBadge'),
                className: c(overflowByDefault && s['overflowed'], overflowByResponsiveDesign && s['overflow-responsive']),
                onClick: ()=>{
                    showAwardBadgePopup(deviation);
                    closeTooltip();
                },
                biData: {
                    evid: BiEventType.GIVE_BADGE_AWARD,
                    sectionname: 'deviation',
                    typeid: deviation.typeId,
                    itemid: deviation.deviationId
                }
            },
            isShareable && {
                value: 'share',
                label: t('actionbar.share'),
                biData: BiData({
                    evid: 355,
                    typeid: getDeviationResourceType(deviation),
                    itemid: deviation.deviationId,
                    deviationid: deviation.deviationId
                }),
                onClick: showDesktopDeviationSharePopup
            },
            isShareable && {
                value: 'shareToPost',
                label: t('actionbar.shareToPost'),
                onClick: restrictToVerifiedAndLoggedIn(ReferralType.SHARE_TO_POST, 'submitstatus', ()=>shareDeviationToPost(deviation)),
                biData: BiData({
                    evid: 356,
                    typeid: getDeviationResourceType(deviation),
                    itemid: deviation.deviationId,
                    social_share: 'da_post',
                    deviationid: deviation.deviationId
                })
            },
            isReportable && {
                value: 'report',
                label: t('actionbar.report'),
                biData: BiData({
                    evid: 20,
                    modal_version: 2,
                    deviationid: deviation.deviationId
                }),
                onClick: ()=>{
                    showReportModal(deviation);
                    closeTooltip();
                }
            },
            !hasNft && isOwner && {
                value: 'linknft',
                label: t('actionbar.linkNft'),
                onClick: ()=>{
                    showNftLinkPopup(deviation);
                    closeTooltip();
                }
            }
        ]
    });
};
MoreMenuContent.displayName = 'MoreMenuContent';
export default MoreMenuContent;
